<script setup lang="ts">
  import { ChevronDown } from 'lucide-vue-next';
  import { ActionMenu, IconImage } from '@/shared/ui';
  import type { ActionMenuItem } from '@/shared/ui/common/ActionMenu.vue';
  import SaveIcon from '@/shared/assets/icons/SaveIcon.svg';

  defineProps<{
    items: ActionMenuItem[];
    disabled?: boolean;
  }>();
</script>

<template>
  <ActionMenu
    :items="items"
    menu-class="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-40 bg-white-01 rounded-2xl shadow-2xl z-50"
  >
    <template #trigger="{ isOpen }">
      <button
        type="button"
        :disabled="disabled"
        class="bg-[var(--theme-secondary)] text-white px-4 py-3 rounded-lg font-medium flex items-center gap-3 md:text-base text-xs h-10.5 disabled:bg-gray-02 disabled:text-gray-16 disabled:opacity-100"
        :class="{ 'cursor-not-allowed': disabled, 'cursor-pointer': !disabled }"
        :data-testid="'save-dropdown-trigger'"
      >
        <IconImage :src="SaveIcon" alt="Salvar" />
        <span>Salvar</span>
        <ChevronDown
          class="size-4 transition-transform"
          :class="{ 'rotate-180': isOpen }"
        />
      </button>
    </template>
  </ActionMenu>
</template>
